var _path, _path2, _circle, _circle2, _circle3, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCombinedOutput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 101,
    viewBox: "0 0 125 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.7 81C124.7 91.88 115.88 100.7 105 100.7L20.0003 100.7C9.12034 100.7 0.300361 91.88 0.30036 81L0.300356 15.0429L124.7 15.0429L124.7 81Z",
    fill: "white",
    stroke: "#D2DBE2",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.302794 15.7818C0.462709 7.20421 7.46598 0.3 16.0818 0.3L108.918 0.3C117.534 0.3 124.537 7.20421 124.697 15.7818L0.302794 15.7818Z",
    fill: "#EBF2F9",
    stroke: "#D2DBE2",
    strokeWidth: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9645,
    cy: 8.04088,
    r: 1.89298,
    fill: "#EBF2F9",
    stroke: "#D2DBE2",
    strokeWidth: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.275,
    cy: 8.04088,
    r: 1.89298,
    fill: "#EBF2F9",
    stroke: "#D2DBE2",
    strokeWidth: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5846,
    cy: 8.04088,
    r: 1.89298,
    fill: "#EBF2F9",
    stroke: "#D2DBE2",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3097 78.7828H53.6894C48.2087 78.7828 43.7656 74.3398 43.7656 68.8591V64.9515C43.7656 63.4104 45.0149 62.1611 46.556 62.1611C48.0971 62.1611 49.3463 63.4104 49.3463 64.9515V68.8591C49.3463 71.2576 51.2906 73.202 53.6892 73.202H71.3095C73.708 73.202 75.6523 71.2576 75.6523 68.8591V64.9515C75.6523 63.4104 76.9016 62.1611 78.4427 62.1611C79.9838 62.1611 81.2331 63.4104 81.2331 64.9515V68.8591C81.2334 74.3398 76.7904 78.7828 71.3097 78.7828Z",
    fill: "#EBF2F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5561 61.4744C44.6386 61.4744 43.0791 63.0339 43.0791 64.9513V68.8588C43.0791 74.7091 47.8394 79.4694 53.6898 79.4694H71.3101C77.1604 79.4694 81.9201 74.7091 81.9201 68.8588V64.9513C81.9201 63.0339 80.3605 61.4744 78.4431 61.4744C76.5257 61.4744 74.9662 63.0339 74.9662 64.9513V68.8588C74.9662 70.8748 73.3263 72.5154 71.3101 72.5154H53.6898C51.6738 72.5154 50.0332 70.8748 50.0332 68.8588V64.9513C50.0332 63.0339 48.4737 61.4744 46.5561 61.4744ZM53.6898 73.8886H71.3101C74.083 73.8886 76.3392 71.6324 76.3392 68.8588V64.9513C76.3392 63.7915 77.2831 62.8474 78.4431 62.8474C79.6029 62.8474 80.5471 63.7913 80.5471 64.9513V68.8588C80.5471 73.9522 76.4037 78.0962 71.3101 78.0962H53.6898C48.5963 78.0962 44.4523 73.9522 44.4523 68.8588V64.9513C44.4523 63.7915 45.3963 62.8474 46.5562 62.8474C47.7162 62.8474 48.6602 63.7913 48.6602 64.9513V68.8588C48.66 71.6326 50.9161 73.8886 53.6898 73.8886Z",
    fill: "#D2DBE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0213 44.42L61.0789 36.8405C61.8478 36.0098 63.1523 36.0098 63.9213 36.8405L66.0565 39.1336L70.9791 44.42C72.1326 45.6626 71.2537 47.688 69.5511 47.688L66.9078 47.688L66.9078 59.9703C66.9078 61.8377 65.7475 63.4374 64.1068 64.0759C63.6125 64.2682 63.0631 64.3781 62.5003 64.3781C61.2851 64.3781 60.1798 63.8838 59.3833 63.0873C58.5869 62.2908 58.0926 61.1924 58.0926 59.9703L58.0926 47.688L55.4494 47.688C53.7466 47.688 52.8678 45.6626 54.0213 44.42Z",
    fill: "#EBF2F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M61.1065 53.0086C61.1065 47.7359 62.9601 42.9095 66.0565 39.1335L70.9791 44.4199C72.1326 45.6625 71.2537 47.6879 69.5511 47.6879L66.9078 47.6879L66.9078 59.9703C66.9078 61.8376 65.7475 63.4374 64.1068 64.0758C62.1983 60.8284 61.1065 57.0456 61.1065 53.0086Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5003 65.0643C65.3082 65.0643 67.593 62.7794 67.593 59.9716L67.593 48.3748L69.5528 48.3748C71.8532 48.3748 73.0443 45.6338 71.4797 43.9518L64.4272 36.3703C63.3802 35.2457 61.6098 35.2555 60.5734 36.3703L53.5208 43.9512C51.9538 45.6359 53.1508 48.375 55.4478 48.375L57.4075 48.375L57.4075 59.9716C57.4075 62.7795 59.6923 65.0643 62.5003 65.0643ZM55.4478 47.0016C54.3461 47.0016 53.7748 45.6939 54.5265 44.8862L61.579 37.3048C62.0742 36.7723 62.9204 36.766 63.4214 37.3048L70.4739 44.8862C71.2243 45.6939 70.6553 47.0016 69.5526 47.0016L66.9064 47.0016C66.5269 47.0016 66.2198 47.3087 66.2198 47.6882L66.2198 59.9716C66.2198 62.0226 64.5511 63.6913 62.5001 63.6913C60.4491 63.6913 58.7804 62.0226 58.7804 59.9716L58.7804 47.6882C58.7804 47.3087 58.4733 47.0016 58.0938 47.0016L55.4478 47.0016Z",
    fill: "#D2DBE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombinedOutput);
export default __webpack_public_path__ + "static/media/combined-output.8c1be58360a6b59df3bf35ba2f3a40bd.svg";
export { ForwardRef as ReactComponent };